import request from "../request"

/**
 * 获取短信验证码
 * @param {*}  phone
 * @param {*}  type  	类型 0 注册 1 重置密码
 * @returns 
 */
const getCode = (phone, type) => request.post(`/v1/nf/user/sms`, { phone, type })

/**
 * 注册
 * @param {*} 
 * @returns 
 */
const register = (queryParams) => request.post(`/v1/nf/user/register`, { ...queryParams })

/**
 * 登录
 * @param {*} 
 * @returns 
 */
const login = (queryParams) => request.post(`/v1/nf/user/login`, { ...queryParams })

/**
 * 重置密码
 * @param {*} 
 * @returns 
 */
const reset = (queryParams) => request.post(`/v1/nf/user/reset/pwd`, { ...queryParams })


/**
 * 获取用户基本信息
 * @param {*}  
 * @returns 
 */
const getBasicInfo = () => request.get(`/v1/nf/basic/user/info`)
const getCompanyInfo = () => request.get(`/v1/nf/certification/mine`)

// 身份认证接口
const apiAuth = {
    // 实名认证
    userAuth: (queryParams) => request.post(`/v1/nf/certification/identity`, { ...queryParams }),

    // 企业认证
    enterAuth: (queryParams) => request.post(`/v1/nf/certification/company`, { ...queryParams }),

    position: (position = []) => request.post(`/v1/nf/user/position`, { position }),

    // 实物支付开关
    paySwitch: (payFlag) => request.post(`/v1/nf/user/reset/pay`, { payFlag }),
}

// 个人中心-服务管理
const apiService = {

    getList: (queryParams) => request.post(`/v1/nf/post/user/search`, { ...queryParams }),

    post: (queryParams) => request.post(`/v1/nf/post`, { ...queryParams }),

    put: (queryParams) => request.put(`/v1/nf/post`, { ...queryParams }),

    del: (id) => request.delete(`/v1/nf/post/${id}`),

    getById: (id) => request.get(`/v1/nf/post/${id}`),

}

// 个人中心-需求管理
const apiDemand = {

    getList: (queryParams) => request.post(`/v1/nf/post/require/user/search`, { ...queryParams }),

    post: (queryParams) => request.post(`/v1/nf/post/require`, { ...queryParams }),

    put: (queryParams) => request.put(`/v1/nf/post/require`, { ...queryParams }),

    del: (id) => request.delete(`/v1/nf/post/require/${id}`),

    getById: (id) => request.get(`/v1/nf/post/require/${id}`),

}

// 个人中心-消息管理
const apiNews = {

    getList: () => request.get(`/v1/nf/chat/list`),

}

// 个人中心-资质
const apiManage = {
    post: (queryParams) => request.post(`/v1/nf/nfUserDetail`, queryParams),

    put: (queryParams) => request.put(`/v1/nf/nfUserDetail`, queryParams),

    search: (type) => request.get(`/v1/nf/nfUserDetail/mine/${type}`),
}

const apiDevs = {
    post: (queryParams) => request.post(`/v1/nf/nfDev`, queryParams),

    search: () => request.get(`/v1/nf/nfDev/mine`),

    bind: (imei) => request.get(`/v1/nf/nfDev/${imei}`),
}

const apiLands = {
    post: (queryParams) => request.post(`/v1/nf/nfLands`, queryParams),

    search: () => request.get(`/v1/nf/nfLands/mine`),
}

const user = {
    getCode,
    register,
    login,
    reset,
    getBasicInfo,
    getCompanyInfo,
    apiManage,
    apiDevs,
    apiLands,
    apiAuth,
    apiService,
    apiDemand,
    apiNews,
}

export default user
